module.exports = __webpack_public_path__ + "img/3.17456247.png";